export const environment = {
  production: false,
  url: 'https://api.analise.people.uat.private.unico.run',
  base_url: 'https://uat-temporary.analise.acessorh.com.br',
  identity_url: 'https://identityhomolog.acesso.io',
  cookie_url: 'https://admin.people.uat.unico.app/svc2/authorize',
  people_url: 'https://admin.people.uat.unico.app/svc2'
};
